


























































































































import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  UserOtherContactsTable,
  UserOtherContactsTableItem
} from '@/components/organisms/UserOtherContactsTable'
import { InputCode } from '@/components/molecules/InputCode'
import { UserDetailStateInfo } from '@/types'

export interface UserContentOtherContactsItem {
  guardian: {
    input: string
    errorMessage: string
  }
  guardianKana: {
    input: string
    errorMessage: string
  }
  workType: {
    input: string
    display: string
    errorMessage: string
  }
  otherContacts: UserOtherContactsTableItem[]
}

export const defaultUserContentOtherContactsItem = (): UserContentOtherContactsItem => ({
  guardian: {
    input: '',
    errorMessage: ''
  },
  guardianKana: {
    input: '',
    errorMessage: ''
  },
  workType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  otherContacts: []
})

@Component({
  components: {
    InputCode,
    UserOtherContactsTable
  }
})
export default class UserContentOtherContacts extends ComponentVue {
  @PropSync('item', {
    type: Object,
    required: true
  })
  inputItem!: UserContentOtherContactsItem

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }
}
